export const SEARCH_SLATE_TIME = 15 * 60 * 1000
